import { zeroPad } from "./zeroPad";
import moment from "jalali-moment";

export const convertMinToFormattedTime = (minuets, round) => {
  let min = minuets % 60;
  let hour = parseInt(minuets / 60);
  min = zeroPad(min);
  const roundedMin = min === "00" ? "" : `:${min}`;
  return round ? `${hour}${roundedMin}` : `${hour}:${min}`;
};

// For example convert "2022/04/03 21:46:36" to "21:46"
export const convertDateTimeToFormattedTime = dateTime => {
  const _dateTime = dateTime.split(" ");
  try {
    if (_dateTime && _dateTime.length > 0) {
      const time = _dateTime[1];
      return moment(time, "HH:mm").format("HH:mm");
    }
  } catch (e) {
    return "--:--";
  }
};
